import { render, staticRenderFns } from "./HotList.vue?vue&type=template&id=31163511&"
import script from "./HotList.vue?vue&type=script&lang=js&"
export * from "./HotList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports